
/* 
 * bigvideo plugin by Nick Braica @ Tank
 * April 27, 2015
 *
 * Use this plugin for full screen background videos
 */

;(function ($, window) {  

    var defaults = {
        ratio : 16/9,
        width : $(window).width(),
    };

    window.video_delta = 0;

    var bufferedPercent = function(player) {
        if(player.buffered.length == 0)
            return 0;
        
        return player.buffered.end(0) / player.duration;
    }

    var sizeVideo = function($node, $player, ratio){
        var nodeHeight   = $node.outerHeight(),
            nodeWidth    = $node.width(),
            playerWidth  = $node.hasClass('river--video-background') ? nodeWidth : $(window).width(),
            playerHeight = Math.ceil(playerWidth / ratio),
            offsetTop    = Math.floor( ( nodeHeight - (Math.ceil( playerWidth / ratio)) ) / 2 ),
            playerStyle  = offsetTop > 0 ? 'top:0; bottom:0;' : 'top: ' + offsetTop + 'px;';

        if(playerHeight < nodeHeight ){
            playerHeight = nodeHeight;
            playerWidth = Math.ceil(playerHeight * ratio);
        }

        if( ! $node.hasClass('river--video-background')){
            playerStyle += ' left: -' + ((playerWidth - nodeWidth) / 2) + 'px;';
        }

        $player.attr('style', playerStyle).attr('height', playerHeight).attr('width', playerWidth);
    }

    var bigvideo = function(node, options){
        var options     = $.extend({}, defaults, options),
            $node       = $(node),
            videoSrc    = $node.data('video') + '',
            posterSrc   = $node.data('poster'),
            playerId    = 'player-' + window.video_delta,
            loaded      = false,

            // test for chrome, since chrome appears to only preload
            //  25% of the video. Current versions (as of 6/1/2015)
            //  of Firefox and Safari appear to preload the entire
            //  video, so we can set the play buffer a bit higher
            bufferLimit = navigator.userAgent.toLowerCase().indexOf('chrome') > -1 ? 0 : .2;

        if(videoSrc.indexOf('http://player.vimeo.com') > -1 || videoSrc.indexOf('https://player.vimeo.com') > -1  ){

            var $iframe = $('<video id="' + playerId + '" class="bigvideo-player" loop preload="auto"><source src="' + videoSrc + '" type="video/mp4"></video>');

            window.video_delta++;

            // build container
            var bigvideoContainer = $('<div class="bigvideo-container"></div>').append($iframe);
            $node.prepend('<div class="bigvideo-shield"></div>').prepend(bigvideoContainer);

            var player = document.getElementById(playerId);

            player.muted = true;

            player.addEventListener('progress', function(){
                var _player  = this,
                    buffered = bufferedPercent(_player);
                    
                if(! loaded && buffered >= bufferLimit){
                    loaded = true;
                    _player.play();
                    $node.addClass('initvideo').removeClass('banner--fixed').css({
                        'position' : 'relative',
                        'zIndex'   : 99
                    });
                }
            });

            sizeVideo($node, $iframe, options.ratio);

            $(window).resize(function(){
                sizeVideo($node, $iframe, options.ratio);
            });
        } else {
            console.error( "Video must be an mp4 from Vimeo." );
        }
    }

    $.fn.bigvideo = function (options) {

        this.each(function(){
            bigvideo(this, options);
        });
    }

})(jQuery, window);